import axios from 'axios'
import qs from 'qs'
import merge from 'lodash/merge'
import sha256 from 'sha256'
import {
  eventBus
} from './eventBus.js'
const http = axios.create({
  timeout: 1000 * 60,
  headers: {
    'Content-type': 'application/x-www-form-urlencoded'
  }
})

/**
 * 请求拦截
 */
http.interceptors.request.use(config => {
  // debugger
  if (config.resTimeout) {
    config.timeout = config.resTimeout
  } else {
    config.timeout = 1000 * 60
  }
  return config
}, error => {
  return Promise.reject(error)
})

/**
 * 响应拦截
 */
http.interceptors.response.use(response => {
  if (response.data && (response.data.code === 444 || response.data.msg === '登录凭证错误')) { // 401, token失效
    // clearLoginInfo()
    localStorage.removeItem('uid')
    localStorage.removeItem('score')
    localStorage.removeItem('money')
    localStorage.removeItem('token')
    // token	16b1d1b3b05b467990b57e12b46140a0
    // router.push({ name: 'login' })
    this.$router.push('login')
  }
  return response
}, error => {
  return Promise.reject(error)
})

/**
 * 请求地址处理
 * @param {*} actionName action方法名称
 */
http.adornUrl = (actionName) => {
  // 自动拼接url
  return 'https://j.chnzxl.com/entrya' + actionName
  // return 'http://192.168.0.166:40002' + actionName
}

/**
 * post请求数据处理
 * @param {*} data 数据对象
 * @param {*} openDefultdata 是否开启默认数据?
 * @param {*} contentType 数据格式
 *  json: 'application/json; charset=utf-8'
 *  form: 'application/x-www-form-urlencoded; charset=utf-8'
 */
http.adornData = (data = {}, actionName, openDefultdata = true, contentType = 'json') => {
  // let moduleId = localStorage.getItem('moduleId')
  // let moduleId = null
  // if (data.moduleId) {
  //   moduleId = data.moduleId
  // }
  // console.log(moduleId)
  // console.log(typeof moduleId)
  var defaults = {
    't': new Date().getTime(),
    'sign': sha256(actionName + localStorage.getItem('token')),
    'userId': localStorage.getItem('uid'),
    'moduleId': localStorage.getItem('moduleId'),
  }
  data = openDefultdata ? merge(defaults, data) : data
  // if (openDefultdata) {
  //   if (!data.moduleId) {
  //     data.moduleId = localStorage.getItem('moduleId')
  //   }
  // }
  // console.log(data)
  return qs.stringify(data)
}

export default http



// WEBPACK FOOTER //
// ./src/assets/js/request.js